import { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CostSettingProfile } from 'lumen/models';
import CentralMappingMappingEntry from 'lumen/models/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryChannel extends CentralMappingMappingEntry {
  // @ts-expect-error: Class inheritance
  [Type] = 'central-mapping/mapping-entry-channel' as const;

  // Set by the backend's auto-mapping. Read-only.
  @belongsTo('cost-setting/profile', { async: false, inverse: null })
  declare autoCostProfile: CostSettingProfile | null;

  @belongsTo('cost-setting/profile', { async: false, inverse: null })
  declare userCostProfile: CostSettingProfile | null;

  get costProfile(): CostSettingProfile | null {
    const { userCostProfile, autoCostProfile } = this;

    return userCostProfile ?? autoCostProfile;
  }
}
